import { render } from "./ServiceFail.vue?vue&type=template&id=4427e035"
import script from "./ServiceFail.vue?vue&type=script&lang=js"
export * from "./ServiceFail.vue?vue&type=script&lang=js"

import "./ServiceFail.vue?vue&type=style&index=0&id=4427e035&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__